<template>
  <div class="car-declare-approval-static u-flex-column">
    <div class="car-declare-approval-static__form">
      <el-form :size="'small'" :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="统计时间">
          <el-date-picker
            style="width: 360px"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            :picker-options="pickerOptions"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="queryForm.checkStatus" style="width: 120px">
            <el-option label="已审批" :value="3" />
            <el-option label="未审批" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="车辆类型">
          <el-select
            v-model="queryForm.vehicleTypes"
            multiple
            collapse-tags
            placeholder="请选择"
            style="width: 260px"
          >
            <el-option
              v-for="item in vehicleTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属企业">
          <el-select
            v-model="queryForm.coIds"
            multiple
            filterable
            collapse-tags
            placeholder="请选择"
            style="width: 320px"
          >
            <el-option
              v-for="item in enterpriseOptions"
              :key="item.id"
              :label="item.coName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">统计</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="car-declare-approval-static__charts" v-loading="loading">
      <div
        v-for="item in chartList"
        :key="item.key"
        class="car-declare-approval-static__chart-panel"
      >
        <div class="car-declare-approval-static__chart-title">
          {{ item.title }}{{ approvalStatusName }}统计
        </div>
        <bar-echart :chart-data="item.chartData" />
      </div>
      <div v-if="!loading && !chartList.length" class="car-declare-approval-static__empty">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import BarEchart from "@/components/echarts/barEchart.vue";

export default {
  name: "CarDeclareApprovalStatic",
  components: {
    BarEchart
  },
  data() {
    return {
      loading: false,
      time: this.getDefaultTime(),
      queryForm: {
        checkStatus: 3,
        vehicleTypes: [3, 2, 1, 4],
        coIds: []
      },
      enterpriseOptions: [],
      chartList: [],
      vehicleTypeOptions: [
        { label: "大货车", value: 3, color: "#3ddc97" },
        { label: "客车", value: 2, color: "#4dabf7" },
        { label: "小轿车", value: 1, color: "#ffd166" },
        { label: "危化品车", value: 4, color: "#f25f5c" }
      ],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() >= today.getTime();
        }
      }
    };
  },
  computed: {
    approvalStatusName() {
      return this.queryForm.checkStatus === 3 ? "已审批" : "未审批";
    }
  },
  methods: {
    pad(value) {
      return value < 10 ? "0" + value : String(value);
    },
    formatDateTime(date, endOfDay) {
      const day = [
        date.getFullYear(),
        this.pad(date.getMonth() + 1),
        this.pad(date.getDate())
      ].join("-");
      return day + (endOfDay ? " 23:59:59" : " 00:00:00");
    },
    getDefaultTime() {
      const end = new Date();
      end.setDate(end.getDate() - 1);
      const start = new Date(end.getTime());
      start.setDate(start.getDate() - 6);
      return [this.formatDateTime(start, false), this.formatDateTime(end, true)];
    },
    getTodayDateText() {
      const today = new Date();
      return [
        today.getFullYear(),
        this.pad(today.getMonth() + 1),
        this.pad(today.getDate())
      ].join("-");
    },
    getColor(typeCode, index) {
      const option = this.vehicleTypeOptions.find(item => item.value === typeCode);
      return option ? option.color : this.vehicleTypeOptions[index % this.vehicleTypeOptions.length].color;
    },
    normalizeEnterpriseList(data) {
      if (!data) {
        return [];
      }
      const list = Array.isArray(data) ? data : [data];
      return list.filter(item => item && item.id).map(item => {
        return {
          id: Number(item.id),
          coName: item.coName || "企业" + item.id
        };
      });
    },
    getEnterpriseList() {
      this.$http.POST_hyEnterpriseByRole({
        pageIndex: 1,
        pageRow: 9999
      }).then(res => {
        this.enterpriseOptions = this.normalizeEnterpriseList(res.data);
        if (!this.queryForm.coIds.length && this.enterpriseOptions.length) {
          this.queryForm.coIds = this.enterpriseOptions.slice(0, 6).map(item => item.id);
        }
        this.getData();
      });
    },
    buildCharts(result) {
      const dates = result.statisticKey || [];
      const colors = this.vehicleTypeOptions.map(item => item.color);
      this.chartList = (result.charts || []).map(chart => {
        const series = (chart.series || []).map((item, index) => {
          return Object.assign({}, item, {
            color: this.getColor(item.typeCode, index)
          });
        });
        return {
          key: chart.coId + "_" + this.queryForm.checkStatus + "_" + new Date().getTime(),
          title: chart.coName || "企业" + chart.coId,
          chartData: {
            name: chart.coName,
            xvalue: dates,
            series,
            colors
          }
        };
      });
    },
    getData() {
      if (!this.time || this.time.length !== 2) {
        this.$message.warning("请选择统计时间");
        return;
      }
      if (this.time[1].slice(0, 10) >= this.getTodayDateText()) {
        this.$message.warning("统计时间不能包含当天");
        return;
      }
      if (!this.queryForm.vehicleTypes.length) {
        this.$message.warning("请选择车辆类型");
        return;
      }
      if (!this.queryForm.coIds.length) {
        this.$message.warning("请选择所属企业");
        return;
      }
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        checkStatus: this.queryForm.checkStatus,
        vehicleTypes: this.queryForm.vehicleTypes,
        coIds: this.queryForm.coIds
      };
      this.loading = true;
      this.$http.POST_carDeclareApprovalStatistic(data).then(res => {
        this.buildCharts(res.data || {});
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.getEnterpriseList();
  }
};
</script>

<style lang="scss">
.car-declare-approval-static {
  height: 100%;
  display: flex;
}

.car-declare-approval-static__form {
  min-height: 118px;
  padding: 26px 40px 0 60px;
}

.car-declare-approval-static__charts {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 40px 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(460px, 1fr));
  gap: 18px;
}

.car-declare-approval-static__chart-panel {
  height: 360px;
  min-width: 0;
  padding-top: 8px;
  border: 1px solid rgba(53, 189, 219, 0.28);
  background: rgba(6, 31, 61, 0.36);
}

.car-declare-approval-static__chart-title {
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 0.18rem;
  color: #fff;
}

.car-declare-approval-static__chart-panel .barechart {
  height: calc(100% - 28px);
}

.car-declare-approval-static__empty {
  grid-column: 1 / -1;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(53, 189, 219, 0.28);
  background: rgba(6, 31, 61, 0.28);
}
</style>



// WEBPACK FOOTER //
// src/views/tjfx/carDeclareApprovalStatic.vue